import React, { Component } from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';

import Layout from './components/Layout/Layout';
import Email from './containers/Email/Email';
import EmailVerification from './containers/EmailVerification/EmailVerification';
import EmailValidate from './containers/EmailValidate/EmailValidate';
import Password from './containers/Password/Password';
import CustomerInfo from './containers/CustomerInfo/CustomerInfo';
import Billing from './containers/Billing/Billing';
import AwsAccount from './containers/AwsAccount/AwsAccount';
import InstallRegion from './containers/InstallRegion/InstallRegion';
import CloudFormation from './containers/CloudFormation/CloudFormation';
import SignupDone from './containers/SignupDone/SignupDone';


class App extends Component {

    render() {
        return (
                <div>
                    <Layout>
                        <Switch>
                            <Route path="/signup/email" component={Email}/>
                            <Route path="/signup/email-verification" component={EmailVerification}/>
                            <Route path="/signup/signup-done" component={SignupDone}/>
                            <Route path="/signup/verify" component={EmailValidate}/>
                            <Route path="/signup/password" component={Password}/>
                            <Route path="/signup/customer-info" component={CustomerInfo}/>
                            <Route path="/signup/billing" component={Billing}/>
                            <Route path="/signup/aws-account" component={AwsAccount}/>
                            <Route path="/signup/install-region" component={InstallRegion}/>
                            <Route path="/signup/cloud-formation" component={CloudFormation}/>
                            <Route path="/signup/" exact component={Email}/>
                            <Route path="/" exact component={Email}/>
                            <Redirect to="/"/>
                        </Switch>
                    </Layout>
                </div>
        );
    }
}

export default App;
